import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Store
import { getProject } from "store/slice/Project";

// Enums
import { urlPaths } from "enums/urlPaths";
import { useAppSelector } from "app/hooks";

const useRedirectOnProjectError = () => {
    const { status: projectDataStatus } = useAppSelector(getProject);
    const navigate = useNavigate();

    useEffect(() => {
        if (projectDataStatus === "error") {
            navigate(urlPaths.NotFound);
        }
    }, [navigate, projectDataStatus]);
};

export default useRedirectOnProjectError;
